export const features = [
  "3500+ QBank Questions",
  "2500+ Recalls Questions",
  "Pre-Exam Assessment of Knowledge",
  "Covers All Patient Groups",
  "Free Test Drive",
  "24X7 Help & Support",
];